export default __webpack_public_path__ + "static/media/bg15.ac0e303d.jpg";